export default function Ichola() {
  const winuptoAmount = "500,000";
  const currency="ZMW"
  return (
    <div className="px-2 md:px-9 md:pr-14  shadow-sm ">
      <div className="my-6  md:rounded-lg bg-[#50010A] border-4 border-t-0 shadow-[#00000086] shadow-md border-[#a70000]  md:bg-[#A70000] text-center  p-4">
        <h1 className="text-white text-md font-bold uppercase">
          ICHOLA MegaBox
        </h1>
        <div className="text-yellow-400 font-bold tracking-wider text-xl">
          Win up to  {winuptoAmount} {currency}
        </div>
      </div>
    </div>
  );
}
